import { render, staticRenderFns } from "./buyFoot.vue?vue&type=template&id=ad719e78&scoped=true&"
import script from "./buyFoot.vue?vue&type=script&lang=js&"
export * from "./buyFoot.vue?vue&type=script&lang=js&"
import style0 from "./buyFoot.vue?vue&type=style&index=0&id=ad719e78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad719e78",
  null
  
)

export default component.exports